import React from 'react';
import { Route, Routes } from 'react-router';

import Customer from './customer/Customer';
import CustomersList from './customers-list/CustomersList';
import CustomerCreate from './customer-create/CustomerCreate';
import CommonPage from '../components/common-page/CommonPage';

const Customers = () => {
  return (
    <CommonPage>
      <Routes>
        <Route path='/' exact element={<CustomersList />} />
        <Route path='/:id' exact element={<Customer />} />
        <Route path='/add' exact element={<CustomerCreate />} />
      </Routes>
    </CommonPage>
  );
};

export default Customers;
